export class SaleOrderDepartureSerialNumber {
  constructor(
    public hash?: string,
    public serialNumber?: string,
    public saleOrderLineHash?: string,
    public saleOrderLineType?: number,
    public saleOrderLineProductName?: string,
    public saleOrderLineProductCode?: string,
    public saleOrderLineProductDescription?: string,
    public saleOrderLineProductNeedSerialNumber?: boolean,
    public saleOrderLineComplementName?: string,
    public saleOrderLineComplementCode?: string,
    public saleOrderLineComplementDescription?: string,
    public saleOrderLineComplementNeedSerialNumber?: boolean
  ) { }

  clone() {
    return new SaleOrderDepartureSerialNumber(
      this.hash,
      this.serialNumber,
      this.saleOrderLineHash,
      this.saleOrderLineType,
      this.saleOrderLineProductName,
      this.saleOrderLineProductCode,
      this.saleOrderLineProductDescription,
      this.saleOrderLineProductNeedSerialNumber,
      this.saleOrderLineComplementName,
      this.saleOrderLineComplementCode,
      this.saleOrderLineComplementDescription,
      this.saleOrderLineComplementNeedSerialNumber
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order-departure-serial-number.ts